import React from "react";
import { Nav, FormGroup, FormInput, Row, Col, Alert } from "../../../components/ui";
import { Link } from "react-router-dom";
import SidebarNavItem from "./SidebarNavItem";
import { Store } from "../../../flux";
import { subscribeToNewsletter } from "../../../api";
import { handleApiError } from "../../../utils/apiErrorHandler";
import {
  captureAffiliateFromSearch,
  getStoredAffiliateKey,
  getStoredMarketingKey,
} from "../../../utils/affiliateTracking";
import publisherStore from "../../../flux/publisherStore";

class SidebarNavItems extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      navItems: Store.getSidebarItems(),
      showNewsletterForm: false,
      showError: false,
      showSuccess: false,
      affiliateLine: "",
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  componentDidMount() {
    Store.addChangeListener(this.onChange);
    let allPublishers = publisherStore.getPublishers();
    if (localStorage.getItem("user") === null) {
      this.setState({
        showNewsletterForm: true,
      });
    }
    let affiliateKey = getStoredAffiliateKey();
    if (affiliateKey) {
      let publisher =
        allPublishers !== null &&
        allPublishers.filter((p) => p.ownAffiliateKey === affiliateKey)[0];
      if (publisher && publisher.name) {
        this.setState({ affiliateLine: ` from ${publisher.name}` });
      }
    }
    captureAffiliateFromSearch(window.location.search);
    const urlParams = new URLSearchParams(window.location.search);
    const affParameter = urlParams.get("aid") || urlParams.get("ref");
    if (affParameter) {
      let publisher =
        allPublishers !== null &&
        allPublishers.filter((p) => p.ownAffiliateKey === affParameter)[0];
      if (publisher && publisher.name) {
        this.setState({ affiliateLine: ` from ${publisher.name}` });
      }
    }
  }

  onChange() {
    this.setState({
      ...this.state,
      navItems: Store.getSidebarItems(),
    });
  }

  newsletterSubscribe = async () => {
    let inviterAffiliateKey = getStoredAffiliateKey();
    let marketingSourceKey = getStoredMarketingKey();
    let res = await subscribeToNewsletter(
      this.state.publicAccessEmail,
      this.state.publicAccessName,
      inviterAffiliateKey,
      marketingSourceKey
    );
    if (res && res.status >= 200 && res.status < 300) {
      this.setState({
        showError: false,
        showSuccess: true,
      });
    } else {
      const errorResponse = handleApiError(res, "Failed to subscribe");
      this.setState({
        showError: true,
        errorText: errorResponse.message,
      });
    }
  };

  render() {
    const { navItems: items } = this.state;
    return (
      <div className="nav-wrapper">
        <Nav className="nav--no-borders flex-column">
          {items.map((item, idx) => (
            <SidebarNavItem key={idx} item={item} />
          ))}
        </Nav>
        {this.state.showNewsletterForm && (
          <div id="get-discount">
            <Row className="justify-content-center">
              <Col md={10} className="newsletter-signup-form">
                <h4>Sign up for free content{this.state.affiliateLine}!</h4>
                <FormGroup className="form-group">
                  <FormInput
                    id="feCurrPass"
                    type="text"
                    placeholder="Name"
                    value={this.state.publicAccessName}
                    onChange={(val) => {
                      this.setState({ publicAccessName: val.target.value });
                    }}
                  />
                </FormGroup>
                <FormGroup className="form-group">
                  <FormInput
                    id="feCurrPass"
                    type="email"
                    placeholder="Email"
                    value={this.state.publicAccessEmail}
                    onChange={(val) => {
                      this.setState({ publicAccessEmail: val.target.value });
                    }}
                  />
                </FormGroup>
                <Link
                  to={"#"}
                  className="alerts-premium-linear"
                  style={{ width: "auto" }}
                  onClick={() => this.newsletterSubscribe()}
                >
                  Subscribe
                </Link>
                <br />
                {this.state.showError && (
                  <Alert className="mb-0">
                    <i className="fa fa-error mx-2"></i>
                    {this.state.errorText}
                  </Alert>
                )}
                {this.state.showSuccess && (
                  <Alert className="mb-0">
                    <i className="fa fa-success mx-2"></i>Thank you for
                    subscribing!
                  </Alert>
                )}
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}

export default SidebarNavItems;
